import * as React from 'react'
import ApiCall from '../../components/ApiCall/ApiCall'

interface AccountVerifProps {
    match: any
}

interface AccountVerifState {
}

export default class VerifAccount extends React.Component<AccountVerifProps, AccountVerifState> {

    private api = new ApiCall()

	constructor(props: AccountVerifProps) {
		super(props)
		this.state = {
		}
    }
    
    async componentDidMount() {
        const request = await this.api.ApiCall("accounts/validate/" + this.props.match.params.id, "GET",{})
        console.log(request)
        if (request.status === 204) {
            window.location.href = "/"
        }
        else {
            window.location.href = "/"
        }
    }

	render() {
        return (
            <>
            </>
        );
    }
}
